/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import queryString from 'query-string';
import {USER_LIST_REQUEST, USER_LIST_SUCCESS, USER_LIST_FAILURE} from "../../types";

const InboxUserListAction = (page = 1, limit = 10, email = null, sort = "-created_at") => ({

    [RSAA]: {
        endpoint: () => {
            let parsed = {
                'limit': limit,
                'page': page,
                'sort': sort
            };

            if (email != null && email !== "") {
                parsed['email'] = email;
            }

            let query_param = queryString.stringify(parsed);
            return `${SERVER_API_FB_BOT}/api/users?${query_param}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            USER_LIST_REQUEST,
            {
                type: USER_LIST_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": USER_LIST_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: USER_LIST_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": USER_LIST_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {InboxUserListAction}